import { useSamplesAirMicrobialBaseDataDeleteMutation } from "@/services/backend/samples/api/air-microbial-base-data-api";
import {
  AirMicrobialBaseData,
  airMicrobialBaseDataKey,
} from "@/services/backend/samples/types/sample-base-data";
import { DeleteSampleBaseDataDialog } from "@/services/backend/samples/components/delete-sample-base-data-dialog";

export function DeleteAirMicrobialBaseDataDialog({
  baseData,
  onDeleted,
}: {
  baseData: AirMicrobialBaseData;
  onDeleted?: () => void;
}) {
  const mutation = useSamplesAirMicrobialBaseDataDeleteMutation();
  return (
    <DeleteSampleBaseDataDialog
      baseData={baseData}
      dataKey={airMicrobialBaseDataKey}
      mutation={mutation}
      onDeleted={onDeleted}
    />
  );
}
